import { FORM_LOADER, DASHBOARD_CONTAINER } from '../../../../types/types';
import { BILLING_TYPE, TERMINAL_PUBLIC, TERMINAL_STATUS, STATE_ABBR } from '../form-terminal-types';
import { dropdown } from '../../../dropdown';
import useAuth from '../../../../hooks/auth-hooks';

import { displayIndividualTerminal } from '../../../../routes/get-terminal-individual';
import { getTerminalTaxes } from '../../../../routes/get-terminal-taxes';
import { getTerminalCardGroup } from '../../../../routes/get-terminal-card-group';

import { displayCardGroupWidget, displayTaxWidget } from './display-terminal-helpers';
import { displayTerminalInformation } from './display-terminal-info';

/**
 * Function to get an individual terminals information
 * 
 * @param {string} terminalId
 * @param {string} partnerId
 * 
 * @returns terminal
 */
export const getIndividualTerminal = async (terminalId: string, partnerId: string) => {
  const { accessType } = useAuth()!;
  const access = accessType === 'E';

  const awsModelData = {
    terminalID: terminalId
  }
  
  const [ terminal, taxes, cardGroup ] = await Promise.all([
    displayIndividualTerminal(terminalId),
    getTerminalTaxes(terminalId),
    getTerminalCardGroup(awsModelData)
  ]);

  const { assigned } = taxes.body;

  dropdown(BILLING_TYPE, 'one', 'Billing Type', false, true, access);
  dropdown(TERMINAL_STATUS, 'two', 'Status', false, true, access);
  dropdown(TERMINAL_PUBLIC, 'public', 'Public', false, true, access);
  dropdown(STATE_ABBR, 'state', 'State', true, true, access);

  FORM_LOADER.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');

  displayTerminalInformation(terminal.body);
  displayCardGroupWidget(terminal.body, cardGroup.body);
  displayTaxWidget(terminal.body, assigned);

  return terminal;
}